"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var coPropTypes = _interopRequireWildcard(require("../helpers/prop-types"));

var calendarHelper = _interopRequireWildcard(require("./calendar-helper"));

var _styler = _interopRequireDefault(require("../Styler/styler"));

var _luxon = require("luxon");

var _lodash = _interopRequireDefault(require("lodash.range"));

var _classnames = _interopRequireDefault(require("classnames"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

// All date operations will be calculated using a default Locale (UTC) in English
_luxon.Settings.defaultLocale = 'en';
_luxon.Settings.defaultZoneName = 'utc';
var LAST_WEEKDAY_INDEX = 6;

function getNextPeriod(date, weekdays) {
  var nextMonth = _luxon.DateTime.local(date.year, date.month, date.daysInMonth).plus({
    days: 1
  });

  var weekDayCurrentMonth = weekdays.indexOf(_luxon.DateTime.local(date.year, date.month, date.daysInMonth).weekdayShort);
  var nextMonthCalendar = weekDayCurrentMonth < LAST_WEEKDAY_INDEX ? (0, _lodash.default)(1, LAST_WEEKDAY_INDEX - weekDayCurrentMonth + 1) : [];
  return {
    year: nextMonth.year,
    month: nextMonth.month,
    days: nextMonthCalendar
  };
}

function getPreviousPeriod(date, weekdays) {
  var previousMonth = _luxon.DateTime.local(date.year, date.month, 1).minus({
    days: 1
  });

  var weekDayPreviousMonth = weekdays.indexOf(previousMonth.weekdayShort);
  var previousMonthCalendar = weekDayPreviousMonth < LAST_WEEKDAY_INDEX ? (0, _lodash.default)(previousMonth.daysInMonth - weekDayPreviousMonth, previousMonth.daysInMonth + 1) : [];
  return {
    year: previousMonth.year,
    month: previousMonth.month,
    days: previousMonthCalendar
  };
}

function getCurrentPeriod(date) {
  return {
    year: date.year,
    month: date.month,
    days: (0, _lodash.default)(1, date.daysInMonth + 1)
  };
}

function getWeekDays(weekStart) {
  var weekStartKey = _luxon.Info.weekdays('short').findIndex(function (weekDay) {
    return weekDay === weekStart;
  });

  return [].concat(_toConsumableArray(_luxon.Info.weekdays('short').slice(weekStartKey)), _toConsumableArray(_luxon.Info.weekdays('short').slice(0, weekStartKey)));
}

function getCalendarInfo(isoDate, weekStart) {
  var date = _luxon.DateTime.fromISO(isoDate);

  var monthInterval = _luxon.Interval.fromDateTimes(_luxon.DateTime.local(date.year, date.month, 1), _luxon.DateTime.local(date.year, date.month, date.daysInMonth).plus({
    days: 1
  }));

  var weekdays = getWeekDays(weekStart);
  var previousPeriod = getPreviousPeriod(date, weekdays);
  var currentPeriod = getCurrentPeriod(date);
  var nextPeriod = getNextPeriod(date, weekdays);
  var currentDateTime = calendarHelper.getCurrentDateTime();
  return {
    calendar: {
      previousPeriod: previousPeriod,
      currentPeriod: currentPeriod,
      nextPeriod: nextPeriod
    },
    today: monthInterval.contains(currentDateTime) ? currentDateTime : null,
    weekdays: weekdays
  };
}

function isDayActive(currentDay, range, startDate) {
  return range ? range.contains(currentDay) || range.end.hasSame(currentDay, 'day') : currentDay.hasSame(startDate, 'day');
}

function onDayEvent(dayEvent, year, month, day) {
  return function () {
    dayEvent({
      year: year,
      month: month,
      day: day
    });
  };
}

var Day = function Day(_ref) {
  var highlighted = _ref.highlighted,
      notThisMonth = _ref.notThisMonth,
      inRange = _ref.inRange,
      isRangeFirst = _ref.isRangeFirst,
      isRangeLast = _ref.isRangeLast,
      children = _ref.children,
      onClick = _ref.onClick,
      onMouseEnter = _ref.onMouseEnter,
      props = _objectWithoutProperties(_ref, ["highlighted", "notThisMonth", "inRange", "isRangeFirst", "isRangeLast", "children", "onClick", "onMouseEnter"]);

  var dayClasses = (0, _classnames.default)({
    'co-calendar__days--current-day': highlighted,
    'co-calendar__days--not-this-month': notThisMonth,
    'co-calendar__days--range': inRange && !(isRangeFirst && isRangeLast),
    'co-calendar__days--first': isRangeFirst,
    'co-calendar__days--last': isRangeLast
  });
  return _react.default.createElement(_styler.default, {
    className: dayClasses,
    modifiers: _objectSpread({}, props, {
      active: props.active || isRangeFirst || isRangeLast
    })
  }, function (styles) {
    return _react.default.createElement("li", {
      className: styles,
      onClick: onClick,
      onMouseEnter: onMouseEnter
    }, _react.default.createElement("a", null, children));
  });
};

var isDayDisabled = function isDayDisabled(disabledDates, day) {
  if (!disabledDates) return false;
  return !!disabledDates.find(function (interval) {
    return interval.contains(day) || interval.start.hasSame(day, 'day') || interval.end.hasSame(day, 'day');
  });
};

var Days = function Days(_ref2) {
  var calendarInfo = _ref2.calendarInfo,
      highlightToday = _ref2.highlightToday,
      startDate = _ref2.startDate,
      endDate = _ref2.endDate,
      hoveredDate = _ref2.hoveredDate,
      onClick = _ref2.onClick,
      onMouseEnter = _ref2.onMouseEnter,
      disabledDates = _ref2.disabledDates,
      props = _objectWithoutProperties(_ref2, ["calendarInfo", "highlightToday", "startDate", "endDate", "hoveredDate", "onClick", "onMouseEnter", "disabledDates"]);

  var luxonStartDate = calendarHelper.getDateInfo(startDate).date;
  var luxonEndDate = hoveredDate ? calendarHelper.getDateInfo(hoveredDate).date : calendarHelper.getDateInfo(endDate).date;
  var rangeInterval = calendarHelper.getDateRange(luxonStartDate, luxonEndDate);
  var disabledIntervals = calendarHelper.getDisabledIntervals(disabledDates);
  return _react.default.createElement("ul", {
    className: "co-calendar__days"
  }, Object.values(calendarInfo.calendar).map(function (period) {
    return period.days.map(function (day) {
      var currentLuxonDay = calendarHelper.createLuxonDay({
        year: period.year,
        month: period.month,
        day: day
      });
      var isActive = isDayActive(currentLuxonDay, rangeInterval, luxonStartDate);
      var dateString = "".concat(period.year, " - ").concat(period.month, " - ").concat(day);
      var isDisabled = isDayDisabled(disabledIntervals, currentLuxonDay);
      return _react.default.createElement(Day, _extends({
        highlighted: highlightToday && calendarInfo.today && calendarInfo.today.hasSame(currentLuxonDay, 'day'),
        active: isActive && !rangeInterval,
        disabled: isDisabled,
        inRange: !!(isActive && rangeInterval),
        isRangeFirst: rangeInterval && rangeInterval.start.hasSame(currentLuxonDay, 'day'),
        isRangeLast: rangeInterval && rangeInterval.end.hasSame(currentLuxonDay, 'day'),
        notThisMonth: period.month !== calendarInfo.calendar.currentPeriod.month,
        onClick: !isDisabled ? onDayEvent(onClick, period.year, period.month, day) : undefined,
        onMouseEnter: !isDisabled ? onDayEvent(onMouseEnter, period.year, period.month, day) : undefined
      }, props, {
        "data-value": dateString,
        key: dateString
      }), day);
    });
  }));
};

var WeekDays = function WeekDays(_ref3) {
  var days = _ref3.days,
      weekdays = _ref3.weekdays;
  return _react.default.createElement("ul", {
    className: "co-calendar__weekdays"
  }, days.map(function (weekDay) {
    return _react.default.createElement("li", {
      key: weekDay
    }, weekdays[weekDay.toUpperCase()]);
  }));
};

var Calendar = function Calendar(_ref4) {
  var date = _ref4.date,
      startDate = _ref4.startDate,
      endDate = _ref4.endDate,
      weekStart = _ref4.weekStart,
      weekdays = _ref4.weekdays,
      disabledDates = _ref4.disabledDates,
      props = _objectWithoutProperties(_ref4, ["date", "startDate", "endDate", "weekStart", "weekdays", "disabledDates"]);

  var calendarInfo = getCalendarInfo(date || startDate, weekStart);
  return _react.default.createElement(_styler.default, {
    className: "co-calendar",
    modifiers: props
  }, function (styles) {
    return _react.default.createElement("div", {
      className: styles
    }, _react.default.createElement(WeekDays, {
      weekdays: weekdays,
      days: calendarInfo.weekdays
    }), _react.default.createElement(Days, _extends({
      calendarInfo: calendarInfo,
      startDate: startDate,
      endDate: endDate,
      disabledDates: disabledDates
    }, props)));
  });
};

Calendar.propTypes = {
  /** {string} Format: @@YYYY-MM-DD@@ */
  date: coPropTypes.date.isRequired,

  /** {const} @@DatePicker.WEEKDAYS.[MON...SUN]@@ */
  weekStart: calendarHelper.oneOfWeekdays,

  /** {object} Object with weekdays in the format of MON...SUN as keys and a three char string as value. Example: {MON: "Mon"} */
  weekdays: (0, _propTypes.shape)({
    MON: _propTypes.string,
    TUE: _propTypes.string,
    WED: _propTypes.string,
    THU: _propTypes.string,
    FRI: _propTypes.string,
    SAT: _propTypes.string,
    SUN: _propTypes.string
  }),

  /** {string} Required if @@hoveredDate@@ or @@endDate@@ are defined; Format: @@YYYY-MM-DD@@ */
  startDate: coPropTypes.date,

  /** {string} Format: @@YYYY-MM-DD@@ */
  hoveredDate: coPropTypes.date,

  /** {string} Format: @@YYYY-MM-DD@@ */
  endDate: coPropTypes.date,
  highlightToday: _propTypes.bool,

  /** {array} Array of obects with the following format: [{ start: @@YYYY-MM-DD@@, end: @@YYYY-MM-DD@@ }] */
  disabledDates: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    start: coPropTypes.date.isRequired,
    end: coPropTypes.date.isRequired
  })),
  onClick: _propTypes.func,
  onMouseEnter: _propTypes.func
};
Calendar.WEEKDAYS = calendarHelper.WeekDays;
Calendar.defaultProps = {
  weekStart: Calendar.WEEKDAYS.SUN,
  weekdays: Calendar.WEEKDAYS,
  onClick: function onClick() {},
  onMouseEnter: function onMouseEnter() {}
};
var _default = Calendar;
exports.default = _default;
Calendar.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "Calendar",
  "props": {
    "weekStart": {
      "defaultValue": {
        "value": "Calendar.WEEKDAYS.SUN",
        "computed": true
      },
      "type": {
        "name": "custom",
        "raw": "calendarHelper.oneOfWeekdays"
      },
      "required": false,
      "description": "{const} @@DatePicker.WEEKDAYS.[MON...SUN]@@"
    },
    "weekdays": {
      "defaultValue": {
        "value": "Calendar.WEEKDAYS",
        "computed": true
      },
      "type": {
        "name": "shape",
        "value": {
          "MON": {
            "name": "string",
            "required": false
          },
          "TUE": {
            "name": "string",
            "required": false
          },
          "WED": {
            "name": "string",
            "required": false
          },
          "THU": {
            "name": "string",
            "required": false
          },
          "FRI": {
            "name": "string",
            "required": false
          },
          "SAT": {
            "name": "string",
            "required": false
          },
          "SUN": {
            "name": "string",
            "required": false
          }
        }
      },
      "required": false,
      "description": "{object} Object with weekdays in the format of MON...SUN as keys and a three char string as value. Example: {MON: \"Mon\"}"
    },
    "onClick": {
      "defaultValue": {
        "value": "() => { }",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "onMouseEnter": {
      "defaultValue": {
        "value": "() => { }",
        "computed": false
      },
      "type": {
        "name": "func"
      },
      "required": false,
      "description": ""
    },
    "date": {
      "type": {
        "name": "custom",
        "raw": "coPropTypes.date.isRequired"
      },
      "required": false,
      "description": "{string} Format: @@YYYY-MM-DD@@"
    },
    "startDate": {
      "type": {
        "name": "custom",
        "raw": "coPropTypes.date"
      },
      "required": false,
      "description": "{string} Required if @@hoveredDate@@ or @@endDate@@ are defined; Format: @@YYYY-MM-DD@@"
    },
    "hoveredDate": {
      "type": {
        "name": "custom",
        "raw": "coPropTypes.date"
      },
      "required": false,
      "description": "{string} Format: @@YYYY-MM-DD@@"
    },
    "endDate": {
      "type": {
        "name": "custom",
        "raw": "coPropTypes.date"
      },
      "required": false,
      "description": "{string} Format: @@YYYY-MM-DD@@"
    },
    "highlightToday": {
      "type": {
        "name": "bool"
      },
      "required": false,
      "description": ""
    },
    "disabledDates": {
      "type": {
        "name": "arrayOf",
        "value": {
          "name": "shape",
          "value": {
            "start": {
              "name": "custom",
              "raw": "coPropTypes.date.isRequired",
              "required": true
            },
            "end": {
              "name": "custom",
              "raw": "coPropTypes.date.isRequired",
              "required": true
            }
          }
        }
      },
      "required": false,
      "description": "{array} Array of obects with the following format: [{ start: @@YYYY-MM-DD@@, end: @@YYYY-MM-DD@@ }]"
    }
  }
};